import { DOMParser, XMLSerializer } from '@xmldom/xmldom';

function appendChild(xmlDoc, parentElement, name: string, text: string | undefined) {
    let childElement = xmlDoc.createElement(name);
    if (typeof text !== 'undefined') {
      let textNode = xmlDoc.createTextNode(text);
      childElement.appendChild(textNode);
    }
    parentElement.appendChild(childElement);
    return childElement;
  }

export const createXmlFile = (language: string, title: string, author: string | undefined, text: string, description: string, externalUrl: string | undefined,
                              publicationYear: string | undefined, publicationLocation: string | undefined, publisher: string | undefined) => {
  const xmlDoc = new DOMParser().parseFromString("<Item></Item>");
  const rootElement = xmlDoc.documentElement;
  appendChild(xmlDoc, rootElement, 'Title', title);
  appendChild(xmlDoc, rootElement, 'Language', language);
  appendChild(xmlDoc, rootElement, 'Description', description);
  appendChild(xmlDoc, rootElement, 'Author', author);
  appendChild(xmlDoc, rootElement, 'Body', text);
  appendChild(xmlDoc, rootElement, 'ExternalUrl', externalUrl);
  appendChild(xmlDoc, rootElement, 'PublicationYear', publicationYear);
  appendChild(xmlDoc, rootElement, 'PublicationLocation', publicationLocation);
  appendChild(xmlDoc, rootElement, 'Publisher', publisher);

  const dt = new Date();
  appendChild(xmlDoc, rootElement, 'Date', dt.toISOString().split('T')[0]);

  const xmlSerializer = new XMLSerializer();
  const xmlOutput = xmlSerializer.serializeToString(xmlDoc);

  console.log("xmlOutput:", xmlOutput);

  return new File([xmlOutput], "filename.xml", {type: "text/xml"});
};